/* unplugin-vue-components disabled */import { render } from "./driver_agreement.vue?vue&type=template&id=07f550ee&scoped=true"
import script from "./driver_agreement.vue?vue&type=script&lang=js"
export * from "./driver_agreement.vue?vue&type=script&lang=js"

import "./driver_agreement.vue?vue&type=style&index=0&id=07f550ee&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f550ee"]])

export default __exports__